export enum AttemptProvisionResult {
  PROVISIONED = "PROVISIONED",
  ERROR = "ERROR",
  UNABLE = "UNABLE",
}
